export const inputTokens = {
  'input-height': '36px',
  'input-height-sm': '28px',
  'input-padding-x': 'var(--dp-spacing-md)',
  'input-font-size': 'var(--dp-font-size-md)',
  'input-bg': 'var(--dp-color-background)',
  'input-border-color': 'var(--dp-color-border)',
  'input-border-color-hover': 'var(--dp-color-border-strong)',
  'input-border-color-focus': 'var(--dp-color-primary)',
  'input-border-radius': 'var(--dp-border-radius-md)',
  'input-placeholder-color': 'var(--dp-color-text-tertiary)',
  'input-error-border-color': 'var(--dp-color-error)',
  'input-disabled-bg': 'var(--dp-color-surface)',
  'input-disabled-opacity': '0.5',
} as const;
